import { ProgressIcon } from '@/app/features/icons/Progress'
import * as React from 'react'
import clx from 'classnames'

export type Stat = {
  label: string
  hours: number
  percent: number
  barColor: string
}

export const StatCard = ({ label, hours, percent, barColor }: Stat) => {
  return (
    <div className="tw-flex tw-w-full tw-flex-col tw-gap-2">
      <div className="tw-text-xs tw-font-medium tw-text-content-base/80">
        {label}
      </div>
      <div
        className="tw-h-1"
        style={{
          background: barColor,
        }}
      />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span
          className={clx(
            `tw-flex tw-items-center tw-mb-0 tw-text-sm tw-font-bold`,
            {
              'tw-text-success': percent > 0,
              'tw-text-error': percent < 0,
            },
          )}
        >
          <ProgressIcon
            className={clx('tw-mr-1 tw-h-4', {
              'tw-rotate-90': percent < 0,
            })}
          />
        </span>
        <span className="tw-text-xs tw-font-normal tw-text-content-base/80">
          {hours.toLocaleString('pl-PL')}h
        </span>
      </div>
      <div className="tw-text-base tw-font-bold tw-text-content-base">
        {percent}%
      </div>
    </div>
  )
}
